import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";

import ImgPhoto from "../../../../resources/console/images/icon/default-user.svg";
import btnMoreinfo from "../../../../resources/preReg/images/icon/btn-moreinfo.svg";

// Swiper 모듈 사용 설정
SwiperCore.use([Pagination]);

const SessionListDetailUserList = (props) => { 
  const { item,setSessionMgrInfoModalShow ,setManagerInfo,paginationShow } = props;
  
  // managerList 갯수에 따라 slidesPerView 설정
  const getSlidesPerView = () => {
    if (!item?.managerList) return 1;
    const count = item.managerList.length;
    return count === 1 ? 1 : count === 2 ? 2 : 3;
  };
  
  return (
    <div className="slide_con">
      <Swiper
        key={`swiper-${paginationShow}`}
        observer={true}
        observeParents={true}
        pagination={paginationShow ? { clickable: true } : false}
        breakpoints={{
          0: {
            slidesPerView: 1.5,  //브라우저가 0보다 클 때
            slidesPerGroup: 1,
            spaceBetween: 30,
            allowTouchMove: item?.managerList?.length == 1 ? false : true,
          },
          768: {
            slidesPerView: getSlidesPerView(),  //managerList 갯수에 따라 동적 설정
            spaceBetween: 30,
            allowTouchMove: item?.managerList?.length <= 3 ? false : true,
          },
        }}
        style={{paddingBottom:`${paginationShow?'30px':'0px'}`}}
      >
          {item?.managerList?.map((item2, k) => (
          <SwiperSlide key={`${item.sessionIdx || 'session'}_manager_${k}_${item2.managerIdx || item2.name || k}`}>
            <div
              className="slide_flex"
              onClick={(e) => (setSessionMgrInfoModalShow(true), setManagerInfo(item2))}
            >
              <div className="slide_flex_div">
                <div className="slide_flex_inner_div">
                  <img
                    className="slide_img"
                    src={
                      item2?.signedUrlPhoto
                        ? item2?.signedUrlPhoto
                        : ImgPhoto
                    }
                    alt="프로필사진"
                  />
                  <img
                    className="slide_img_more"
                    src={btnMoreinfo}
                    alt="더보기"
                  />
                </div>
              </div>
              <div className="slide_flex_t">
                <b>
                  {item2?.mgrType === "SEAT"
                    ? "좌장"
                    : item2?.mgrType === "PANEL"
                    ? "패널"
                    : "연자"}
                </b>
                <h2>{item2?.name}</h2>
                <p>
                  {item2?.brieflyMark ? item2?.brieflyMark : (
                    <>
                      {item2.companyName && <span>{item2.companyName}</span>}
                      {item2.deptName && <span>{item2.deptName}</span>}
                    </>
                  )}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default SessionListDetailUserList;